import { Box, Divider, Stack, StackProps, Typography } from '@mui/material';
import React from 'react';
import { SURFACE_BORDER_COLOR, surfaceSx } from '../../styles/tokens';

interface BoxWithHeader extends Omit<StackProps, 'title'> {
  title: string | React.ReactNode;
  extra?: React.ReactNode;
  fullHeight?: boolean;
  hasError?: boolean;
  header?: React.ReactNode;
}

export const BoxWithHeader = ({ title, children, header, extra, fullHeight, hasError, ...props }: BoxWithHeader) => (
  <>
    <Stack
      sx={{
        ...surfaceSx,
        padding: '1.5rem',
        height: fullHeight ? 1 : 'auto',
        borderColor: hasError ? 'error.main' : SURFACE_BORDER_COLOR,
        position: 'relative'
      }}
      {...props}
    >
      {header}
      {typeof title === 'string' ? (
        <Typography variant="h6" fontWeight="bold">
          {title}
        </Typography>
      ) : (
        title
      )}
      <Box my={2}>
        <Divider />
      </Box>
      {children}
    </Stack>
    {extra}
  </>
);
